import { useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  makeStyles,
  TextField,
  Avatar,
  Badge,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import {
  useDataProvider,
  Loading,
  useAuthenticated,
  Error,
  useTranslate,
} from "react-admin";

import useOccupations from "../../../hooks/useOccupations";
import NumberFormatInput from "../../../components/NumberFormatInput";
import { converttoWgPhoneFormat } from "../../../utils";
import ErrorDialog from "../../../components/ErrorDialog";
import {
  removeEmptyFieldfromObject,
  removeEmptyStringFieldfromObject,
} from "../../../utils";
//import useAddressInfo from "../../../hooks/useAddressInfo";
import ConfirmationView from "./ConfirmationView";
import SuccessView from "./SuccessView";
import EditIcon from "../../../assets/icons/edit.png";
import usePotentialForm from "../../../hooks/usePotentialForm";
import FullAddressInput from "../../../components/FullAddressInput";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 20,
    paddingLeft: 81,
    paddingRight: 81,
    boxSizing: "border-box",
  },
  header: {
    marginTop: 36,
  },
  titleSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleSection_rightZone: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
  },
  titleSection_rightZone_dateCreated: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    flexDirection: "column",
  },
  fullname_gender_leftSection: {
    width: 680,
  },
  uploadImage_RightSection: {
    paddingLeft: 10,
    paddingRight: 10,
    boxSizing: "border-box",
    width: 200,
  },
  fullnameSection: {
    display: "flex",
    alignItems: "baseline",
    flexDirection: "column",
  },
  fullnameLanguageSpecificSection: {
    marginTop: 12,
    flexDirection: "row",
  },
  phoneEmailSection: {
    marginTop: 12,
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  occupationNationSection: {
    marginTop: 12,
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  addressRecommendSection: {
    marginTop: 12,
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  proceedButtonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  proceedButton: {
    marginTop: 50,
    width: 322,
    height: 57,
    fontSize: 28,
    backgroundColor: theme.potentialBlue,
  },
  textFieldHeight: {
    height: theme.defaultTextFieldHeight,
  },
  subAddressContainer: {
    width: "100%",
    flexDirection: "row",
    display: "flex",

    justifyContent: "space-between",
  },
  uploadImage_paper: {
    width: "100%",
    height: "100%",
    paddingTop: 19,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  editIcon: {
    height: 27,
    width: 27,
  },
  avatar: {
    width: "114px",
    height: "114px",
    fontSize: 50,
    color: theme.potentialBlue,
    borderWidth: 10,
    backgroundColor: theme.white,
  },
  avatarBorder: {
    justifyContent: "center",
    display: "flex",
    width: "114px",
    height: "114px",
    alignItem: "center",
    borderColor: theme.potentialBlue,
  },
  referContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
  },
  occupationRow: {
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
  },
  selected: {
    backgroundColor: theme.potentialBlue + "!important",
  },
  toggleButton: {
    borderColor: theme.potentialBlue,
    color: theme.potentialBlue,
  },
}));

const initialRegisterData = {
  firstname: "",
  lastname: "",
  nickname: "",

  phone: "",
  email: "",
  gender: "Other",
  birthdate: "",
  occupation: "",
  nationality: "",
  state: "",
  address: "",
  subdistrict: "",
  district: "",
  province: "",
  postcode: "",
  locale: "th-TH",
  status: "Active",
  invite_code: "",
};

const validationRules = {
  firstname: { required: true, rule: () => true },
  lastname: { required: true, rule: () => true },
  nickname: { required: false, rule: () => true },
  phone: {
    required: true,
    rule: (phone) => phone.length === 10,
    message: "Phone number is not valid",
  },
  email: {
    rule: (email) =>
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        String(email).toLowerCase()
      ),
    message: "Email format is not valid",
  },
  birthdate: {
    rule: (bday) => {
      try {
        if (bday.length < 1) {
          return false;
        }
        new Date(bday);
        return true;
      } catch (error) {
        return false;
      }
    },
    message: "Birthdate format is not valid",
  },
  gender: { required: true, rule: () => true },
  occupation: { rule: () => true },
  nationality: { rule: () => true },
  state: { rule: () => true },
  address: { rule: () => true },
  subdistrict: { rule: () => true },
  district: { rule: () => true },
  province: { rule: () => true },
  postcode: { rule: () => true },
  locale: { rule: () => true },
  image: { rule: () => true },
  status: { rule: () => true },
  recommended_by: { rule: () => true },
  invite_code: { rule: () => true },
};

const textFieldValidate = (validator, key) => {
  return {
    error: validator && validator[key],
    helperText: validator && validator[key] ? validator[key] : null,
  };
};

const PotentialRegister = () => {
  useAuthenticated();
  const { occupations, loading, error } = useOccupations();
  // const {
  //   subDistricts,
  //   postcodes,
  //   provinces,
  //   districts,
  //   loading: addressLoading,
  //   error: addressError,
  // } = useAddressInfo();
  const classes = useStyles();
  const translate = useTranslate();
  const [registerData, setRegisterData] = useState(initialRegisterData);
  const [validateError, setValidateError] = useState();
  const dataProvider = useDataProvider();
  const [image, setImage] = useState("");
  const [step, setStep] = useState({ step: 0, data: null }); //step=0 form 1 confirm/error 3 complete
  let [showError, setShowError] = useState({ error: false, message: "" });
  const { form, loading: formLoading, error: formError } = usePotentialForm();
  const onChangeHandler = (value, key) => {
    if (key === "province") {
      setRegisterData({
        ...registerData,
        province: value,
        district: "",
        subdistrict: "",
        postcode: "",
      });
    } else if (key === "district") {
      setRegisterData({
        ...registerData,
        district: value,
        subdistrict: "",
        postcode: "",
      });
    } else if (key === "subdistrict") {
      setRegisterData({
        ...registerData,
        subdistrict: value,
        postcode: "",
      });
    } else setRegisterData({ ...registerData, [key]: value });

    //make error message disapear
    let tempValidateError = { ...validateError };
    delete tempValidateError[key];
    setValidateError({ ...tempValidateError });
  };

  const onCompleteHandler = () => {
    try {
      const validateResult = Object.entries(registerData).reduce(
        (total, [key, value]) => {
          if (validationRules[key].required && (!value || value === "")) {
            return { ...total, [key]: "This field is required" };
          } else if (!value || value === "") {
            return total;
          } else {
            if (!validationRules[key].rule(value)) {
              return { ...total, [key]: validationRules[key].message };
            } else return total;
          }
        },
        {}
      );

      if (Object.keys(validateResult).length > 0) {
        setValidateError(validateResult);
      } else setStep({ step: 1, data: null });
    } catch (error) {
      alert("Error" + JSON.stringify(error));
    }
  };

  const onChangeSelectImageHandler = (file) => {
    //Simple Validate image
    if (file.size > 10000000) {
      return;
    }

    setRegisterData({
      ...registerData,
      image: {
        rawFile: file,
        src: URL.createObjectURL(file),
        title: "profile",
      },
    });
    setImage(URL.createObjectURL(file));

    //{"rawFile":{"path":"download (1).png"},"src":"blob:http://localhost:3000/3b381ad1-7a70-4c28-9773-88af0834607c","title":"download (1).png"}}
  };

  if (loading || formLoading) return <Loading></Loading>;
  if (error || formError) return <Error />;

  const genderList = form.fields.find((field) => field.id === "gender").values;
  const marriageStatusList = form.fields.find(
    (field) => field.id === "state"
  ).values;

  return (
    <Box className={classes.allContainer}>
      {step.step === 0 ? (
        <>
          <Typography variant="h6" align="center" className={classes.header}>
            {translate("ra.text.ci.addPotential")}
          </Typography>
          <form noValidate autoComplete="off">
            <Box className={classes.titleSection}>
              <Typography variant="subtitle2">
                {translate("ra.text.inputInformation.personasInformation")}
              </Typography>
              <Box className={classes.titleSection_rightZone}>
                <Box>
                  <Button disabled={true} variant="contained" color="primary">
                    QR
                  </Button>
                </Box>
              </Box>
            </Box>

            <Typography variant="body2">
              {translate("ra.text.ci.generalInformation.fullName")} *
            </Typography>
            <Box style={{ display: "flex", flexDirection: "row" }}>
              <Box className={classes.fullname_gender_leftSection}>
                <Box className={classes.fullnameSection}>
                  <Box className={classes.fullnameLanguageSpecificSection}>
                    <TextField
                      required
                      variant="outlined"
                      placeholder={translate(
                        "ra.text.ci.generalInformation.firstName"
                      )}
                      value={registerData.firstname}
                      {...textFieldValidate(validateError, "firstname")}
                      onChange={(e) =>
                        onChangeHandler(e.target.value, "firstname")
                      }
                      style={{ width: 231 }}
                    />
                    <TextField
                      required
                      variant="outlined"
                      placeholder={translate(
                        "ra.text.ci.generalInformation.lastName"
                      )}
                      value={registerData.lastname}
                      {...textFieldValidate(validateError, "lastname")}
                      onChange={(e) =>
                        onChangeHandler(e.target.value, "lastname")
                      }
                      style={{ width: 231, marginLeft: 8 }}
                    />
                    <TextField
                      required
                      variant="outlined"
                      placeholder={translate(
                        "ra.text.ci.generalInformation.nickName"
                      )}
                      value={registerData.nickname}
                      {...textFieldValidate(validateError, "nickname")}
                      onChange={(e) =>
                        onChangeHandler(e.target.value, "nickname")
                      }
                      style={{ width: 198, marginLeft: 8 }}
                    />
                  </Box>
                </Box>
                <Box className={classes.phoneEmailSection}>
                  <Box style={{ flexGrow: 3 }}>
                    <Typography variant="body2">
                      {translate("ra.text.ci.generalInformation.phoneNumber")} *
                    </Typography>
                    <NumberFormatInput
                      required
                      type="tel"
                      format="###-###-####"
                      placeholder={translate(
                        "ra.text.ci.generalInformation.phoneNumber"
                      )}
                      {...textFieldValidate(validateError, "phone")}
                      value={registerData.phone}
                      onValueChange={({ formattedValue, value }) =>
                        onChangeHandler(value, "phone")
                      }
                      style={{ width: "100%" }}
                    />
                  </Box>
                  <Box style={{ flexGrow: 3, marginLeft: 23 }}>
                    <Typography variant="body2">
                      {translate("ra.text.ci.generalInformation.email")}
                    </Typography>
                    <TextField
                      {...textFieldValidate(validateError, "email")}
                      variant="outlined"
                      placeholder={translate(
                        "ra.text.ci.generalInformation.email"
                      )}
                      value={registerData.email}
                      onChange={(e) => onChangeHandler(e.target.value, "email")}
                      type="email"
                      style={{ width: "100%" }}
                    />
                  </Box>
                  <Box style={{ flexGrow: 1, marginLeft: 23 }}>
                    <Typography variant="body2">
                      {translate("ra.text.ci.generalInformation.birthday")}
                    </Typography>
                    <NumberFormatInput
                      variant="outlined"
                      format="##-##-####"
                      {...textFieldValidate(validateError, "birthdate")}
                      value={registerData.birthdate}
                      placeholder="dd-mm-yyyy"
                      onValueChange={({ formattedValue, value }) =>
                        onChangeHandler(formattedValue, "birthdate")
                      }
                      style={{ width: "100%" }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box className={classes.uploadImage_RightSection}>
                <Paper className={classes.uploadImage_paper}>
                  <Box
                    border={5}
                    borderRadius="50%"
                    className={classes.avatarBorder}
                  >
                    <input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        onChangeSelectImageHandler(e.target.files[0])
                      }
                    />
                    <label htmlFor="contained-button-file">
                      <Badge
                        overlap="circle"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        badgeContent={
                          <Avatar
                            alt="edit"
                            src={EditIcon}
                            className={classes.editIcon}
                          />
                        }
                      >
                        <Avatar
                          src={image}
                          alt="?"
                          className={classes.avatar}
                        />
                      </Badge>
                    </label>
                  </Box>
                </Paper>
              </Box>
            </Box>
            <Box className={classes.occupationNationSection}>
              <Box style={{ flexGrow: 1 }}>
                <Typography variant="body2">
                  {translate("ra.text.ci.generalInformation.gender")} *
                </Typography>

                <ToggleButtonGroup
                  value={registerData.gender}
                  exclusive
                  onChange={(_, currentSelection) => {
                    if (currentSelection === null) return;
                    onChangeHandler(currentSelection, "gender");
                  }}
                >
                  {genderList.map((g) => (
                    <ToggleButton
                      classes={{ selected: classes.selected }}
                      value={g.code}
                      className={classes.toggleButton}
                    >
                      {g.name}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Box>

              <Box style={{ flexGrow: 3, marginLeft: 23 }}>
                <Typography variant="body2">
                  {translate("ra.text.ci.generalInformation.nationality")}
                </Typography>
                <Box style={{ display: "flex" }}>
                  <ToggleButton
                    value="check"
                    selected={registerData.nationality === "Thai"}
                    onClick={() => {
                      onChangeHandler("Thai", "nationality");
                    }}
                    classes={{
                      root: classes.toggleButton,
                      selected: classes.selected,
                    }}
                  >
                    Thai
                  </ToggleButton>
                  <TextField
                    variant="outlined"
                    placeholder="Other"
                    style={{ marginLeft: 8 }}
                    onChange={(e) =>
                      onChangeHandler(e.target.value, "nationality")
                    }
                    value={
                      registerData.nationality !== "Thai"
                        ? registerData.nationality
                        : ""
                    }
                  />
                </Box>
              </Box>
              <Box style={{ flexGrow: 3, marginLeft: 23 }}>
                <Typography variant="body2">
                  {translate("ra.text.ci.generalInformation.status")}
                </Typography>
                <Box style={{ display: "flex" }}>
                  <ToggleButtonGroup
                    value={registerData.state}
                    exclusive
                    onChange={(_, currentSelection) =>
                      //setMarriageStatus(currentSelection);
                      onChangeHandler(currentSelection, "state")
                    }
                  >
                    {marriageStatusList.map((m) => (
                      <ToggleButton
                        classes={{ selected: classes.selected }}
                        value={m.code}
                        className={classes.toggleButton}
                      >
                        {m.name}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                  <TextField
                    value={
                      registerData.state !== "single" &&
                      registerData.state !== "married"
                        ? registerData.state
                        : ""
                    }
                    placeholder="Other"
                    style={{ marginLeft: 8 }}
                    variant="outlined"
                    onChange={(e) => onChangeHandler(e.target.value, "state")}
                  />
                </Box>
              </Box>
            </Box>
            <Box className={classes.addressRecommendSection}>
              <Box>
                <Typography variant="body2">
                  {translate("ra.text.ci.generalInformation.address")}
                </Typography>
                <Box className={classes.subAddressContainer}>
                  <TextField
                    style={{
                      width: 300,
                    }}
                    placeholder={translate(
                      "ra.text.inputInformation.addressHint"
                    )}
                    onChange={(e) => onChangeHandler(e.target.value, "address")}
                    variant="outlined"
                    value={registerData.address}
                  />
                  <FullAddressInput onChangeHandler={onChangeHandler} />
                </Box>
              </Box>
            </Box>
            <Box className={classes.occupationRow}>
              <Box style={{ flexGrow: 1 }}>
                <Typography variant="body2">
                  {translate("ra.text.ci.generalInformation.occupation")}
                </Typography>
                <Autocomplete
                  options={occupations}
                  value={registerData.occupation}
                  getOptionLabel={(option) => option.name}
                  onChange={(_, newValue) => {
                    onChangeHandler(newValue, "occupation");
                  }}
                  style={{ width: 231 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Occupation"
                      variant="outlined"
                    />
                  )}
                />
              </Box>
            </Box>
            <Box className={classes.proceedButtonContainer}>
              <Button
                variant="contained"
                className={classes.proceedButton}
                color="primary"
                onClick={() => onCompleteHandler()}
              >
                {translate("ra.text.proceed")}
              </Button>
            </Box>
          </form>
        </>
      ) : step.step === 1 ? (
        <ConfirmationView
          registerData={{
            ...registerData,
            occupation: registerData.occupation
              ? registerData.occupation.name
              : null,
            address: `${registerData.address} 
            ${registerData.subdistrict ? registerData.subdistrict.name : ""} 
            ${registerData.district ? registerData.district.name : ""} 
            ${registerData.province ? registerData.province.name : ""} 
            ${registerData.postcode ? registerData.postcode.code : ""}`,
          }}
          onClickEdit={() => setStep({ step: 0 })}
          onConfirm={() => {
            const cleanRegisterData = {
              ...registerData,
              firstname: registerData?.firstname,
              lastname: registerData?.lastname,
              nickname: registerData?.nickname,
              phone: converttoWgPhoneFormat(registerData.phone),
              birthdate: registerData.birthdate
                ? registerData.birthdate.split("-").reverse().join("-")
                : null,
              occupation_id: registerData.occupation
                ? registerData.occupation.id
                : "",
              district_id: registerData.district
                ? registerData.district.id
                : "",
              subdistrict_id: registerData.subdistrict
                ? registerData.subdistrict.id
                : "",
              province_id: registerData.province
                ? registerData.province.id
                : "",
              postcode_id: registerData.postcode
                ? registerData.postcode.id
                : "",
              invite_codes:
                registerData.invite_code && registerData.invite_code !== null
                  ? new Array(registerData.invite_code)
                  : "",
              postcode: "",
              district: "",
              occupation: "",
              subdistrict: "",
              province: "",
            };

            const removedEmptyField =
              removeEmptyFieldfromObject(cleanRegisterData);
            const removedBlankField =
              removeEmptyStringFieldfromObject(removedEmptyField);

            dataProvider
              .create("potentials", {
                data: { i18n: {}, ...removedBlankField },
              })
              .then((res) => {
                return setStep({ step: 2, id: res.data.id });
              })
              .catch((error) => {
                setShowError({
                  error: true,
                  code: error.code,
                  message: `${error.message}`,
                });
              });
          }}
        />
      ) : (
        <SuccessView potentialId={step.id} />
      )}

      <ErrorDialog
        open={showError.error}
        onClose={() => {
          setShowError({ error: false, message: "" });
        }}
        errorTitle={"Error!!"}
        errorMessage={showError.message}
        code={showError.code}
      />
    </Box>
  );
};

export default PotentialRegister;
